import { useEffect, useState } from 'react';

const FALLBACK_HEADER_HEIGHT_PX = 64;

export function useHeaderOffset(): number {
  const [offset, setOffset] = useState(FALLBACK_HEADER_HEIGHT_PX);

  useEffect(() => {
    const header = document.querySelector('header');
    if (!header) return;

    const measure = () => setOffset(Math.round(header.getBoundingClientRect().height));
    measure();

    if (typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(measure);
    observer.observe(header);
    return () => observer.disconnect();
  }, []);

  return offset;
}
